import { Box, CheckBox, ColorOptions, Spacer, TextNew } from '@jfs/ui-new'
import { FC } from 'react'
import { FlatList } from 'react-native'
import { Colors, SnakeCase } from '../../../util/util'
import { styles } from '../styles'
import { FilterItemProps } from '../types'

const FilterItem: FC<FilterItemProps> = ({ mode, updateFilters, filterData, checkSelected, show }: FilterItemProps) => {
  if (!show) {
    return null
  }

  const filtersObj = filterData[mode]
  const keys = Object.keys(filtersObj)
  const filterChild = ({ item }: any) => {
    const handleFilter = (): void => {
      updateFilters(mode, item)
    }
    return (
      <Box onPress={handleFilter} testID="handleFilter" {...styles.filterItem}>
        <CheckBox
          checked={checkSelected(mode, item)}
          onChange={handleFilter}
          color={checkSelected(mode, item) ? 'PRIMARY' : 'BLACK'}
          iconSize={16}
        />
        <Spacer size={16} direction="horizontal" />
        <TextNew
          fontFamily="JioType-Medium"
          color={Colors.BLACK_14 as ColorOptions}
          fontSize={14}
          lineHeight={20}
          letterSpacing={-0.07}>
          {filtersObj[item] ?? SnakeCase(item)}
        </TextNew>
      </Box>
    )
  }

  return <FlatList data={keys} renderItem={filterChild} />
}

export { FilterItem }
